import { IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCheckbox, IonContent, IonDatetime, IonIcon, IonInput, IonItem, IonLabel, IonNote, IonPage, IonSelect, IonSelectOption, IonTitle, IonToolbar, withIonLifeCycle, IonRadioGroup, IonRadio, IonItemDivider } from "@ionic/react";
import { arrowBack, barbell, manOutline, womanOutline } from "ionicons/icons";
import moment from "moment";
import React from "react";
import AcrofitHeader from "../components/AcrofitHeader";
import { HideLoader, ShowLoader, ShowToast } from "../components/Alerts";
import db from "../components/Database";
import { LOCAL_CONFIG, soloNumeros, soloTexto } from "../components/Funciones";
import { tabla_imc } from "../components/ResumenIMC";
import icon_alarma from "../images/icon_alarma.svg";
import logo_acromax from "../images/logo_acromax.svg";
import logo_salud from "../images/logo_salud.svg";
import IActividadFisica from "../interfaces/IActividadFisica";
import IAlarma from "../interfaces/IAlarma";
import IDatosIniciales from "../interfaces/IDatosIniciales";
import IUsuario from "../interfaces/IUsuario";
import { get, post } from "../Rest";
import { PanelResumen } from "../components/ResumenIMC";

class SigninPage extends React.Component{

    state = {
        usuarios: {
            fecha_nacimiento: moment().add(-18,"years").format(),
            genero:"M"
        } as IUsuario,
        datos_iniciales: {
            actividad_fisica:"1",
            kilos_semanales:"-1000"
        } as IDatosIniciales,
        actividades_fisicas: [] as Array<IActividadFisica>,
        alarmas: {
          desayuno:"07:00",
          media_manana:"10:00",
          almuerzo:"13:00",
          media_tarde:"16:00",
          cena:"19:00",
          activo:"0"
        } as IAlarma,
        steep: 0,
        plan:undefined as number|undefined
      }

    async ionViewDidEnter(){
        const actividades_fisicas = await get("cat/actividades_fisicas")
        await db.cat_actividades_fisicas.bulkPut(actividades_fisicas)
        await this.setState({actividades_fisicas})
    }

    handleDatosPersonales = async (e:any) => {
      await this.setState({usuarios:{...this.state.usuarios,[e.target.name]:e.detail.value}})
    }
  
    handleDatosIniciales = async (e:any) => {
      await this.setState({datos_iniciales:{...this.state.datos_iniciales,[e.target.name]:e.detail.value}})
    }
  
    handleAlarmas = async (e:any) => {
      await this.setState({alarmas:{...this.state.alarmas,[e.target.name]:e.detail.value}})
    }
  
    handleActivarAlarma = async (e:any) => {
      await this.setState({alarmas:{...this.state.alarmas,activo:e.detail.checked?"1":"0"}})
    }
  
    handleChangePlan = async (kilos:number,tmb:number,peso_ideal:number) => {
        const {datos_iniciales} = this.state
        const calorias_dia = (tmb+kilos).toFixed(0)
        const peso_objetivo = kilos === 0 ? datos_iniciales.peso : peso_ideal
        const kilos_semanales = Math.abs(kilos/1000).toFixed(1)
        await this.setState({plan:kilos,datos_iniciales:{...this.state.datos_iniciales,calorias_dia,peso_objetivo,kilos_semanales}})
    }

    render(){
        const {usuarios,alarmas,datos_iniciales,actividades_fisicas,steep,plan} = this.state
        switch(steep){
            case 0:
              return <FormGenerales
                      onChange={this.handleDatosPersonales}
                      data={usuarios}
                      onNext={() => this.setState({steep:1})} />
            case 1:
              return <FormIniciales
                      onChangePersonales={this.handleDatosPersonales}
                      data={usuarios}
                      onChangeIniciales={this.handleDatosIniciales}
                      datos_iniciales={datos_iniciales}
                      onBack={() => this.setState({steep:0})}
                      onNext={() => this.setState({steep:2})}
                      actividades_fisicas={actividades_fisicas} />
            case 2:
              return <FormAlarmas
                      onChange={this.handleAlarmas}
                      onChangeActivo={this.handleActivarAlarma}
                      data={alarmas}
                      onBack={() => this.setState({steep:1})}
                      onNext={() => this.setState({steep:3})}/>
            case 3:
              return <FormSeleccionarPlan
                      onChange={this.handleDatosIniciales}
                      datos_iniciales={datos_iniciales}
                      plan={plan}
                      onChangePlan={this.handleChangePlan}
                      usuario={usuarios}
                      actividades_fisicas={actividades_fisicas}
                      onBack={() => this.setState({steep:1})}
                      onNext={this.registrar}/>
            default:
              return <div></div>
          }
    }

    registrar = async () => {
      const {usuarios,datos_iniciales,alarmas} = this.state
      await ShowLoader()
      const json = await post("registro",{usuarios,datos_iniciales,alarmas})
      HideLoader()
      if(json.error){
        ShowToast(json.error||"Error en el servicio","Registro","danger")
      }else{
        window.location.href = "/login"
      }
    }
}

export default withIonLifeCycle(SigninPage)

const FormGenerales:React.FC<{onChange:any,data:IUsuario,onNext:any}> = (props) => {
    return (
        <IonPage>
            <AcrofitHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton routerDirection="back" routerLink="/login" ><IonIcon icon={arrowBack} /></IonButton>
                    </IonButtons>
                    <IonTitle>Datos Generales</IonTitle>
                </IonToolbar>
            </AcrofitHeader>
            <IonContent className="no-bg">
                <form onSubmit={e => {e.preventDefault(); props.onNext(); return false;}}>
                    <IonItem>
                        <IonLabel>Nombre:</IonLabel>
                        <IonInput className="ion-text-right" type="text" onKeyPress={soloTexto} name="nombres" maxlength={150} onIonChange={props.onChange} required />
                    </IonItem>
                    <IonItem>
                        <IonLabel>Apellidos:</IonLabel>
                        <IonInput className="ion-text-right" type="text" onKeyPress={soloTexto} name="apellidos" maxlength={150} onIonChange={props.onChange} required />
                    </IonItem>
                    <IonItem>
                        <IonLabel>Email:</IonLabel>
                        <IonInput className="ion-text-right" type="email" name="correo" maxlength={250} onIonChange={props.onChange} required />
                    </IonItem>
                    <IonItem>
                        <IonLabel>Contraseña:</IonLabel>
                        <IonInput className="ion-text-right" type="password" name="password" onIonChange={props.onChange} required />
                    </IonItem>
                    <IonToolbar>
                        <IonButtons slot="end">
                            <IonButton fill="solid" color="primary" type="submit">Siguiente</IonButton>
                        </IonButtons>
                    </IonToolbar>
                    <IonItem lines="none" className="no-bg">
                        <div style={{display:"flex",justifyContent:"center",width:"100%"}}>
                            <img src={logo_acromax} alt="Acromax" className="img-fluid mr-2" width={60} />
                        </div>
                    </IonItem>
                    <IonItem lines="none" className="no-bg">
                        <div style={{display:"flex",justifyContent:"center",width:"100%"}}>
                            <img src={logo_salud} alt="#SuSaludNosMueve" className="img-fluid" width={200} />
                        </div>
                    </IonItem>
                </form> 
            </IonContent>
        </IonPage>
    )
}

const FormIniciales:React.FC<{onChangePersonales:any,onChangeIniciales:any,data:IUsuario,datos_iniciales:IDatosIniciales,actividades_fisicas:Array<IActividadFisica>,onNext:any,onBack:any}> = (props) => {
    return (
        <IonPage>
            <AcrofitHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton routerDirection="back" routerLink="/login" ><IonIcon icon={arrowBack} /></IonButton>
                    </IonButtons>
                    <IonTitle>Cálculo de calorías</IonTitle>
                </IonToolbar>
            </AcrofitHeader>
            <IonContent className="no-bg">
                <form onSubmit={e => {e.preventDefault(); props.onNext(); return false;}}>
                    <IonItem>
                        <IonLabel>Fecha nacimiento:</IonLabel>
                        <IonDatetime pickerFormat="DD/MMM/YYYY" displayFormat="DD/MMM/YYYY" monthShortNames={LOCAL_CONFIG.monthsShort} value={props.data.fecha_nacimiento} max={moment().add(-18,"years").format("YYYY-MM-DD")} min={moment().add(-120,"years").format("YYYY-MM-DD")} name="fecha_nacimiento" onIonChange={props.onChangePersonales} />
                    </IonItem>
                    <IonItem lines="none">
                        <IonNote>La fecha de nacimiento es requerida para calcular el IMC, no puede ser menor a 18 años</IonNote>
                    </IonItem>
                    <IonItem>
                        <IonLabel>Genero:</IonLabel>
                        <IonSelect onIonChange={props.onChangePersonales} value={props.data.genero} >
                            <IonSelectOption value="M">Masculino</IonSelectOption>
                            <IonSelectOption value="F">Femenino</IonSelectOption>
                        </IonSelect>
                    </IonItem>
                    <IonItem>
                        <IonLabel>Altura (cm):</IonLabel>
                        <IonInput className="ion-text-right" type="number"  step="1" min="100" max="250" name="altura" onKeyPress={soloNumeros} onIonChange={props.onChangePersonales} required />
                    </IonItem>
                    <IonItem>
                        <IonLabel>Peso (kg):</IonLabel>
                        <IonInput className="ion-text-right" type="number"  step="1" min="0" max="500" name="peso" onKeyPress={soloNumeros} onIonChange={props.onChangeIniciales} required />
                    </IonItem>
                    <IonItemDivider>Actividad Física</IonItemDivider>
                    <IonItem>
                        <IonSelect onIonChange={props.onChangeIniciales} value={props.datos_iniciales.actividad_fisica} >
                        {
                            props.actividades_fisicas.map((af,i) => (
                                <IonSelectOption value={af.id} key={i}>{af.nombre}</IonSelectOption>
                            ))
                        }
                        </IonSelect>
                    </IonItem>
                    <IonCard color="tertiary">
                        <IonCardHeader>Formula de cálculo de Harris Benedict:</IonCardHeader>
                        <IonCardContent>
                            <IonItem color="tertiary">
                                <IonIcon icon={manOutline} slot="start" /> 
                                <p>{"TMB = 66 + (13,7 x peso) + (5 x altura) - (6,75 x edad)"}</p>
                            </IonItem>
                            <IonItem color="tertiary">
                                <IonIcon icon={womanOutline} slot="start" /> 
                                <p>{"TMB = 655 + (9,6 x peso) + (1.8 x altura) - (4,7 x edad)"}</p>
                            </IonItem>
                            <IonItem color="tertiary">
                                <IonIcon icon={barbell} slot="start" /> 
                                <p>{"CALORÍAS = TMB * ACTIVIDAD FÍSICA"}</p>
                            </IonItem>
                        </IonCardContent>
                    </IonCard>
                    <IonToolbar>
                        <IonButtons slot="end">
                            <IonButton fill="solid" color="primary" type="submit">Siguiente</IonButton>
                        </IonButtons>
                        <IonButtons slot="start">
                            <IonButton fill="solid" color="secondary" routerDirection="back" onClick={props.onBack}>Regresar</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </form> 
            </IonContent>
        </IonPage>
    )
}

const FormAlarmas:React.FC<{onChange:any,onChangeActivo:any,data:IAlarma,onNext:any,onBack:any}> = (props) => {
    return (
        <IonPage>
            <AcrofitHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton routerDirection="back" routerLink="/login" ><IonIcon icon={arrowBack} /></IonButton>
                    </IonButtons>
                    <IonTitle>Datos Generales</IonTitle>
                </IonToolbar>
            </AcrofitHeader>
            <IonContent className="no-bg">
                <form onSubmit={e => {e.preventDefault(); props.onNext(); return false;}}>
                <IonCard color="primary">
                        <IonCardContent>
                                <IonItem>
                                    <IonIcon icon={icon_alarma} slot="start" />
                                    <IonLabel>Desayuno</IonLabel>
                                    <IonDatetime cancelText="cancelar" onIonChange={props.onChange} value={props.data.desayuno} name="desayuno" pickerFormat="HH:mm" displayFormat="HH:mm" />
                                </IonItem>
                        </IonCardContent>
                    </IonCard>
                    <IonCard color="secondary">
                        <IonCardContent>
                                <IonItem>
                                    <IonIcon icon={icon_alarma} slot="start" />
                                    <IonLabel>Media mañana</IonLabel>
                                    <IonDatetime cancelText="cancelar" onIonChange={props.onChange} value={props.data.media_manana} name="media_manana" pickerFormat="HH:mm" displayFormat="HH:mm" />
                                </IonItem>
                        </IonCardContent>
                    </IonCard>
                    <IonCard color="tertiary">
                        <IonCardContent>
                                <IonItem>
                                    <IonIcon icon={icon_alarma} slot="start" />
                                    <IonLabel>Almuerzo</IonLabel>
                                    <IonDatetime cancelText="cancelar" onIonChange={props.onChange} value={props.data.almuerzo} name="almuerzo" pickerFormat="HH:mm" displayFormat="HH:mm" />
                                </IonItem>
                        </IonCardContent>
                    </IonCard>
                    <IonCard color="success">
                        <IonCardContent>
                                <IonItem>
                                    <IonIcon icon={icon_alarma} slot="start" />
                                    <IonLabel>Media tarde</IonLabel>
                                    <IonDatetime cancelText="cancelar" onIonChange={props.onChange} value={props.data.media_tarde} name="media_tarde" pickerFormat="HH:mm" displayFormat="HH:mm" />
                                </IonItem>
                        </IonCardContent>
                    </IonCard>
                    <IonCard color="warning">
                        <IonCardContent>
                                <IonItem>
                                    <IonIcon icon={icon_alarma} slot="start" />
                                    <IonLabel>Cena</IonLabel>
                                    <IonDatetime cancelText="cancelar" onIonChange={props.onChange} value={props.data.cena} name="cena" pickerFormat="HH:mm" displayFormat="HH:mm" />
                                </IonItem>
                        </IonCardContent>
                    </IonCard>
                    <IonCard color="danger">
                        <IonCardContent>
                                <IonItem>
                                    <IonCheckbox slot="start" color="danger" name="activo" checked={props.data.activo === "1"} onIonChange={props.onChangeActivo}  />
                                    <IonLabel>Activar alarma</IonLabel>
                                </IonItem>
                        </IonCardContent>
                    </IonCard>
                    <IonToolbar>
                        <IonButtons slot="end">
                            <IonButton fill="solid" color="primary"  type="submit">Siguiente</IonButton>
                        </IonButtons>
                        <IonButtons slot="start">
                            <IonButton fill="solid" color="secondary" routerDirection="back" onClick={props.onBack}>Regresar</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </form> 
            </IonContent>
        </IonPage>
    )
}

const FormSeleccionarPlan:React.FC<{onChange:any,usuario:IUsuario,datos_iniciales:IDatosIniciales,actividades_fisicas:Array<IActividadFisica>,onNext:any,onBack:any,plan:number|undefined,onChangePlan:any}> = (props) => {
    const {peso,actividad_fisica} = props.datos_iniciales
    const {genero,altura,fecha_nacimiento} = props.usuario
    const valor = parseFloat(props.actividades_fisicas.find(ac => ac.id === actividad_fisica)?.valor||"0")
    const edad = -moment(fecha_nacimiento).diff(moment(),"years")

    const tasa_peso = genero==="M"?13.5:9.6
    const tasa_edad = genero==="M"?6.75:4.7
    const tasa_altura = genero==="M"?5:1.8
    const tasa_base = genero==="M"?66:655
    const tmb = (tasa_base + (tasa_peso*parseInt(peso)) - (tasa_edad*edad) + (tasa_altura*parseInt(altura)))*valor
    console.log(actividad_fisica,tasa_base,(tasa_peso*parseInt(peso)),(tasa_edad*edad),(tasa_altura*parseInt(altura)),valor)
    const imc = parseFloat(peso)*10000/(parseFloat(altura)*parseFloat(altura))
    const valor_imc = tabla_imc[genero].find(c => c.min<=imc && c.max>imc)
    const valor_ideal = tabla_imc[genero].find(c => c.variant === "success")
    const tmb_ideal = (((valor_ideal?.max||0)+(valor_ideal?.min||0))/2)*tmb/imc
    //Formula de Lorentz
    const peso_ideal = parseFloat(altura) - 100 - ((parseFloat(altura)-150)/(genero==="M"?4:2.5))
    console.log("TMB:"+tmb)
    return (
        <IonPage>
            <AcrofitHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton routerDirection="back" routerLink="/login" ><IonIcon icon={arrowBack} /></IonButton>
                    </IonButtons>
                    <IonTitle>Cálculo de calorías</IonTitle>
                </IonToolbar>
            </AcrofitHeader>
            <IonContent className="no-bg">
                <form onSubmit={e => {e.preventDefault(); props.onNext(); return false;}}>
                    <PanelResumen genero={props.usuario.genero} imc={imc} valor_imc={valor_imc}  />
                    <IonItem>
                        <IonLabel>Peso actual:</IonLabel>
                        <IonInput className="ion-text-right" value={peso+"kg"} readonly />
                    </IonItem>
                    <IonItem>
                        <IonLabel>Peso ideal:</IonLabel>
                        <IonInput className="ion-text-right" value={peso_ideal.toFixed(0)+"kg"} readonly />
                    </IonItem>
                    <IonItemDivider>Plan:</IonItemDivider>
                    <IonRadioGroup value={props.plan} onIonChange={e => props.onChangePlan(e.detail.value,tmb,peso_ideal)}>
                    <IonItem lines="full">
                        <IonRadio slot="start" value={-1000} />
                        <IonLabel>Bajar 1kg semanal</IonLabel>
                    </IonItem>
                    <IonItem lines="full">
                        <IonRadio slot="start" value={-500} />
                        <IonLabel>Bajar 1/2kg semanal</IonLabel>
                    </IonItem>
                    <IonItem lines="full">
                        <IonRadio slot="start" value={0} />
                        <IonLabel>Mantener peso</IonLabel>
                    </IonItem>
                    <IonItem lines="full">
                        <IonRadio slot="start" value={500} />
                        <IonLabel>Subir 1/2kg semanal</IonLabel>
                    </IonItem>
                    <IonItem lines="full">
                        <IonRadio slot="start" value={1000} />
                        <IonLabel>Subir 1kg semanal</IonLabel>
                    </IonItem>
                    </IonRadioGroup>
                    <IonToolbar>
                        {
                            props.plan !== undefined && (
                                <IonButtons slot="end">
                                    <IonButton fill="solid" color="primary" type="submit">Finalizar</IonButton>
                                </IonButtons>
                            )
                        }
                        <IonButtons slot="start">
                            <IonButton fill="solid" color="secondary" routerDirection="back" onClick={props.onBack}>Regresar</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </form> 
            </IonContent>
        </IonPage>
    )
}